/**
 * Generated by orval v6.10.1 🍺
 * Do not edit manually.
 * API Reference
 * OpenAPI spec version: 1.0
 */

/**
 * Intent of the instruction that caused the transaction
 */
export type TransactionIntent = typeof TransactionIntent[keyof typeof TransactionIntent];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TransactionIntent = {
  transfer: 'transfer',
  topup: 'topup',
  payout: 'payout',
} as const;
